/*@ngInject*/
const UIDraggableSectionDirective = function ($rootScope, $timeout, formMediator, formViewerConstant, authorizationConstants, currentUserModel) {

    let linkFunction = function ($scope, $elm) {

        let element = $($elm),
            selectionContainer = element.find('.sectionSelectionContainer'),
            rootFormId = $scope.sectionStructure.rootFormId,
            isTopDropAttempt,
            isBottomDropAttempt,
            userCanManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);

        if (userCanManageForms) {
            element.attr('draggable', 'true');
        }

        function selectThisSection() {
            $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, null);
            $rootScope.$broadcast(formViewerConstant.configuration.event.SECTION_SELECTION_CHANGE, $scope.sectionStructure);
            $timeout(function () {
            }, 0);
        }

        function onMouseUp(event) {
            let className = event.target.className,
                isClickingSection = className.indexOf('sectionContainer') !== -1,
                isClickingSelectionContainer = className.indexOf('sectionSelectionContainer') !== -1,
                isClickingRow = className.indexOf('formRow') !== -1;

            if (isClickingRow || isClickingSection || isClickingSelectionContainer) {
                selectThisSection();
            }
        }

        function onMouseMove(event) {
            let className = event.target.className,
                isOverSection = className.indexOf('sectionContainer') !== -1;

            if (isOverSection) {
                selectionContainer.addClass('selectable');
            }
            else {
                selectionContainer.removeClass('selectable');
            }
        }

        function onMouseLeave(event) {
            selectionContainer.removeClass('selectable');
        }


        function onDragStart(event) {
            let dataTransfer = event.originalEvent.dataTransfer,
                isDraggingSection = event.target.className.indexOf('sectionEditor') !== -1,
                dragConfiguration = {
                    formStructureType: formViewerConstant.configuration.formStructureType.SECTION,
                    dragType: formViewerConstant.configuration.dragOperationType.MOVE,
                    sectionStructureId: $scope.sectionStructure.sectionStructureId
                };

            if (isDraggingSection) {
                selectThisSection();
                element.addClass('dragging');
                dataTransfer.effectAllowed = 'move';
                event.originalEvent.dataTransfer.setData('text', JSON.stringify(dragConfiguration));
                formMediator.setCurrentDragItem(dragConfiguration);
            }
        }

        function onDragOver(event) {
            let dataTransfer = event.originalEvent.dataTransfer,
                currentTarget = $(event.currentTarget),
                isElementBeingDragged = currentTarget.hasClass('dragging'),
                currentDragConfig = formMediator.getCurrentDragItem(),
                isDraggingSection = currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.SECTION,
                offsetY,
                height;

            if (!isElementBeingDragged && isDraggingSection) {

                offsetY = event.clientY - element.offset().top;
                height = currentTarget.height();
                isTopDropAttempt = offsetY < (height / 2);
                isBottomDropAttempt = offsetY > (height / 2);

                element.removeClass('dragOverTop');
                element.removeClass('dragOverBottom');

                if (isTopDropAttempt) {
                    element.addClass('dragOverTop');
                }
                else if (isBottomDropAttempt) {
                    element.addClass('dragOverBottom');
                }

                dataTransfer.dropEffect = 'move';
                event.preventDefault();
            }
        }

        function onDragLeave() {
            element.removeClass('dragOverTop');
            element.removeClass('dragOverBottom');
        }

        function handleMoveDropOperation(dropConfiguration) {
            let elementToMoveSectionId = dropConfiguration.sectionStructureId,
                elementToMoveSelector = '.' + elementToMoveSectionId,
                elementToMove,
                dropZoneSectionId = $scope.sectionStructure.sectionStructureId,
                dropZoneTarget,
                takeAction = isTopDropAttempt || isBottomDropAttempt;

            if (takeAction) {
                dropZoneTarget = $('.' + dropZoneSectionId);
                elementToMove = $(elementToMoveSelector).detach();

                elementToMove.removeClass('dragging');

                if (isTopDropAttempt) {
                    formMediator.moveSection(rootFormId, elementToMoveSectionId, dropZoneSectionId, formViewerConstant.configuration.INSERT_ABOVE);
                    elementToMove.insertBefore(dropZoneTarget);
                }
                else if (isBottomDropAttempt) {
                    formMediator.moveSection(rootFormId, elementToMoveSectionId, dropZoneSectionId, formViewerConstant.configuration.INSERT_BELOW);
                    elementToMove.insertAfter(dropZoneTarget);
                }
            }
        }

        function handleInsertDropOperation(dropConfiguration) {
            let takeAction = isTopDropAttempt || isBottomDropAttempt,
                moveActionResult,
                newSectionConfiguration,
                dropZoneSectionId = $scope.sectionStructure.sectionStructureId;

            if (takeAction) {
                if (isTopDropAttempt) {
                    moveActionResult = formMediator.createSection(rootFormId, dropConfiguration, dropZoneSectionId, formViewerConstant.configuration.INSERT_ABOVE);
                }
                else {
                    moveActionResult = formMediator.createSection(rootFormId, dropConfiguration, dropZoneSectionId, formViewerConstant.configuration.INSERT_BELOW);
                }

                newSectionConfiguration = {
                    sectionStructure: moveActionResult.movedElement,
                    dropZoneSection: element,
                    createAfterDropZone: isBottomDropAttempt
                };

                $rootScope.$broadcast(formViewerConstant.configuration.event.CREATE_NEW_SECTION, newSectionConfiguration);
            }
        }

        function onDrop(event) {
            let dataTransfer = event.originalEvent.dataTransfer,
                dropConfiguration = JSON.parse(dataTransfer.getData('text')),
                isInsertDropOperation = dropConfiguration.dragType === formViewerConstant.configuration.dragOperationType.INSERT,
                isMoveDropOperation = dropConfiguration.dragType === formViewerConstant.configuration.dragOperationType.MOVE,
                currentDragConfig = formMediator.getCurrentDragItem(),
                isDraggingSection = currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.SECTION;

            if(isDraggingSection) {
                if (isInsertDropOperation) {
                    handleInsertDropOperation(dropConfiguration);
                }
                else if (isMoveDropOperation) {
                    handleMoveDropOperation(dropConfiguration);
                }

                element.removeClass('dragOverTop');
                element.removeClass('dragOverBottom');

                event.preventDefault();
                return false;
            }
        }

        function onDragEnd(event) {
            let className = event.target.className,
                isClickingSection = className.indexOf('sectionContainer') !== -1,
                isClickingRow = className.indexOf('formRow') !== -1;

            element.removeClass('dragOverTop');
            element.removeClass('dragOverBottom');
            element.removeClass('dragging');

            if (isClickingRow || isClickingSection) {
                selectThisSection();
            }
        }

        element.on('mouseup', onMouseUp);
        element.on('mouseleave', onMouseLeave);
        element.on('mousemove', onMouseMove);

        element.on('dragstart', onDragStart);
        element.on('dragover', onDragOver);
        element.on('dragleave', onDragLeave);
        element.on('drop', onDrop);
        element.on('dragend', onDragEnd);

        $scope.$on(formViewerConstant.configuration.event.DELETE_SECTION, function (event, sectionStructureId) {
            if ($scope.sectionStructure.sectionStructureId === sectionStructureId) {
                $scope.resetComponent(element.parent(), $scope.sectionStructure);
            }
        });

        $scope.$on(formViewerConstant.event.formBuilder.DISABLE_DRAGGABLE_ELEMENTS, function () {
            element.attr('draggable', 'false');
        });

        $scope.$on(formViewerConstant.event.formBuilder.ENABLE_DRAGGABLE_ELEMENTS, function () {
            element.attr('draggable', 'true');
        });

        $scope.$on('$destroy', function () {
            element.off('mouseup', onMouseUp);
            element.off('mouseleave', onMouseLeave);
            element.off('mousemove', onMouseMove);
            element.off('dragstart', onDragStart);
            element.off('dragover', onDragOver);
            element.off('dragleave', onDragLeave);
            element.off('drop', onDrop);
            element.off('dragend', onDragEnd);
        });
    };

    return {
        link: linkFunction,
        restrict: 'A'
    };
};

angular.module('umFormViewer')
    .directive('uiDraggableSection', UIDraggableSectionDirective);
